import { useEffect, useState } from "react";
import { WhatsappLogo, X } from "@phosphor-icons/react";
import { useLang } from "../context/LanguageContext";

const PHONE = "244925687036";

const PROMPT = {
  pt: {
    title: "Fale connosco no WhatsApp",
    desc: "Equipa disponível em horário comercial. Respondemos rapidamente a pedidos de orçamento e assistência.",
    cta: "Abrir conversa",
    preset:
      "Olá TVCabSat, gostaria de mais informações sobre os vossos serviços.",
    online: "Online",
  },
  en: {
    title: "Chat with us on WhatsApp",
    desc: "Our team is available during business hours. We reply fast to quote and support requests.",
    cta: "Start chat",
    preset: "Hello TVCabSat, I'd like more information about your services.",
    online: "Online",
  },
  es: {
    title: "Habla con nosotros en WhatsApp",
    desc: "Equipo disponible en horario comercial. Respondemos rápido a presupuestos y soporte.",
    cta: "Iniciar conversación",
    preset:
      "Hola TVCabSat, me gustaría recibir más información sobre sus servicios.",
    online: "En línea",
  },
};

export const WhatsAppFab = () => {
  const { lang } = useLang();
  const t = PROMPT[lang] || PROMPT.pt;
  const [open, setOpen] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const link = `https://wa.me/${PHONE}?text=${encodeURIComponent(t.preset)}`;

  return (
    <div
      data-testid="whatsapp-fab-wrapper"
      className={`fixed bottom-6 right-6 z-[60] transition-all duration-500 ${
        visible
          ? "translate-y-0 opacity-100"
          : "pointer-events-none translate-y-4 opacity-0"
      }`}
    >
      {open && (
        <div
          data-testid="whatsapp-popover"
          className="mb-3 w-[320px] origin-bottom-right overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-2xl shadow-slate-900/15 animate-in fade-in slide-in-from-bottom-2"
        >
          <div className="flex items-center gap-3 border-b border-slate-200 bg-gradient-to-r from-green-500/10 to-transparent px-4 py-3">
            <div className="relative inline-flex h-10 w-10 items-center justify-center overflow-hidden rounded-full ring-2 ring-green-500/30">
              <img
                src="/avatar-support-male.png"
                alt=""
                aria-hidden
                className="h-full w-full object-cover"
              />
              <span className="absolute -bottom-0.5 -right-0.5 h-3 w-3 rounded-full border-2 border-white bg-green-500" />
            </div>
            <div className="flex-1">
              <div className="text-sm font-semibold text-slate-900">TVCabSat</div>
              <div className="flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-widest text-green-600">
                <span className="pulse-dot !h-1.5 !w-1.5" />
                {t.online}
              </div>
            </div>
            <button
              data-testid="whatsapp-close"
              onClick={() => setOpen(false)}
              aria-label="Fechar"
              className="inline-flex h-7 w-7 items-center justify-center rounded-full border border-slate-200 text-slate-500 transition-colors hover:bg-slate-100 hover:text-slate-900"
            >
              <X size={12} weight="bold" />
            </button>
          </div>
          <div className="px-4 py-4">
            <div className="font-heading text-[15px] font-semibold leading-snug text-slate-900">
              {t.title}
            </div>
            <p className="mt-1.5 text-xs leading-relaxed text-slate-600">
              {t.desc}
            </p>
            <div className="mt-3 rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 font-mono text-[11px] text-slate-700">
              +244 925 687 036
            </div>
            <a
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="whatsapp-cta-link"
              onClick={() => setOpen(false)}
              className="mt-4 inline-flex w-full items-center justify-center gap-2 rounded-full bg-green-500 px-4 py-2.5 text-sm font-semibold text-white transition-all hover:bg-green-400 active:scale-95"
            >
              <WhatsappLogo size={16} weight="fill" />
              {t.cta}
            </a>
          </div>
        </div>
      )}

      <button
        data-testid="whatsapp-fab"
        aria-label="WhatsApp"
        onClick={() => setOpen((v) => !v)}
        className="group relative inline-flex h-16 w-16 items-center justify-center overflow-hidden rounded-full bg-white text-white shadow-xl shadow-green-600/40 ring-2 ring-green-500 transition-all hover:scale-105 hover:ring-green-400 active:scale-95 md:h-[72px] md:w-[72px]"
      >
        <span className="absolute inset-0 rounded-full bg-green-500/30 opacity-60 blur-md transition-opacity group-hover:opacity-90" />
        <span className="absolute inset-0 animate-ping rounded-full bg-green-500/30" />
        {open ? (
          <X size={26} weight="bold" className="relative z-10 text-slate-700" />
        ) : (
          <>
            <img
              src="/avatar-support-male.png"
              alt=""
              aria-hidden
              className="relative z-10 h-full w-full object-cover"
            />
            {/* WhatsApp marker badge so users still recognize the platform */}
            <span className="absolute -bottom-0.5 -right-0.5 z-20 inline-flex h-6 w-6 items-center justify-center rounded-full border-2 border-white bg-green-500 shadow-md md:h-7 md:w-7">
              <WhatsappLogo size={14} weight="fill" className="text-white" />
            </span>
          </>
        )}
      </button>
    </div>
  );
};
